import { render, staticRenderFns } from "./CreateGroupDialog.vue?vue&type=template&id=3801a332&"
import script from "./CreateGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateGroupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGroupDialog.vue?vue&type=style&index=0&id=3801a332&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports